// Wrapper for react-native as perforamnce is not yet available

let performanceObject;
try {
  performanceObject = performance;
} catch (e) {
  performanceObject = Date;
}

export default performanceObject;
